import { getGoalName, getName } from '../../financialEntities';
import { sortBy } from '../../util/arrays';
import { dt } from '../../util/dateTime';
import { pascaleToSentenceCase } from '../../util/strings';
import {
    getLastUpdatedBalanceDate,
    isLatestBalanceAccurate,
    isLinkingInProgress,
} from '../financialEntities';
import { getPreferredOrFirstName, UserInfo } from '../user';
import { Account } from './useAccounts';

export interface AccountListItemInfo {
    category: string;
    title: string;
    subtitle?: string | undefined | null;
    value?: number | null;
    lastUpdated: string;
    lastUpdatedISO: string;
    isLatestBalanceAccurate: boolean;
    isLinkingInProgress?: boolean;
}

export const getAccountListItemInfo = ({
    userInfo,
    account,
}: {
    userInfo: UserInfo;
    account: Account;
}): AccountListItemInfo => {
    const category = pascaleToSentenceCase(account.category);

    if (account.__typename === 'Goal') {
        const lastUpdates = account
            ? account.financialEntities.map((fe) =>
                  getLastUpdatedBalanceDate(fe)
              )
            : [];
        const lastUpdatedRaw = dt(
            sortBy(lastUpdates, (u) => u.toDateStr(), 'DESC').at(0) ??
                account.updatedAt ??
                account.createdAt
        );
        const subtitle =
            account.accountStructure === 'JOINT'
                ? 'Joint'
                : account.accountStructure === 'SPLIT'
                  ? 'Split'
                  : getPreferredOrFirstName(userInfo);

        return {
            title: getGoalName(account, { withPlentyPrefix: true }),
            subtitle,
            value: account.value,
            lastUpdated: lastUpdatedRaw.fromNow(),
            lastUpdatedISO: lastUpdatedRaw.toISOString(),
            isLatestBalanceAccurate: true,
            category,
        };
    }

    if (account.type === 'PlentyGoalAccount') {
        return {
            title: getName(account),
            value: account.value,
            lastUpdatedISO: getLastUpdatedBalanceDate(account).toISOString(),
            lastUpdated: getLastUpdatedBalanceDate(account).fromNow(),
            isLatestBalanceAccurate: true,
            category,
        };
    }

    // Must be external FE
    return {
        title: getName(account),
        value: account.value,
        lastUpdatedISO: getLastUpdatedBalanceDate(account).toISOString(),
        lastUpdated: getLastUpdatedBalanceDate(account).fromNow(),
        isLatestBalanceAccurate: isLatestBalanceAccurate(account),
        category,
        isLinkingInProgress: isLinkingInProgress(account),
    };
};
